<script setup>
import Popup from './popup.vue';
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal';
import { deviceStore } from './../stores/deviceStore'

const store = deviceStore();
</script>

<script>
export default {
  components: {
      Popup,
   },
  data: () => ({
    DeepLinkpopupshow: false,
    initialContext:"",
    viewport: "",
    meetingInfo:{},
    form: null,
  }),
  mounted() {
    },
  beforeDestroy() {
    if (this.form) {
      this.form.destructor();
    }
  },
  computed:{
  },
  methods: {
    createDeepLink: function() {
      console.log("got initial context",this.initialContext);
      var client = window.botStore.getClientByViewPort(this.viewport); 
      let GrantPath = JSON.parse(client.CurrentContext);
      let GrantPE = GrantPath.GrantPE;
      let InitialContext = document.getElementById('initialContext').value;
      let LocationContext = JSON.parse(client.LocationContext);
      console.log("location context",LocationContext);
      let signedURL = LocationContext.origin + '/DeviceManager/index.html';
      console.log("location context signedurl",signedURL);
      //let signedURL = '/DeviceManager/index.html';

      $.ajax({
      type:"POST",
      url:"/BotServices/bot/getSignedUrl",
      data: JSON.stringify({"Role":'visitor',"Component":client.ClientRight,"URL":signedURL,"InitialContext":InitialContext}),
      dataType:"json",
      contentType:"application/json",
      success: function(res) {
          console.log("Got HTTP Response signedurl");
          console.log(res);
         // document.getElementById("meetshorturl").innerHTML= res.ShortURL;   
          //document.getElementById("deeplinkdiv").style.display = "";
        }
      });
      //window.DevMgr.setMeeting(document.getElementById('initialContext').value);
      this.DeepLinkpopupshow = false;
    },
    showDeepLinkPopUp : function(client,viewport,store) {
      console.log("====show pop up===="+this.DeepLinkpopupshow);
      this.DeepLinkpopupshow = true;
      this.viewport = viewport;
      this.form = new dhx.Form(this.$refs.form, {
      css: "dhx_widget--bg_white",
      width: "100%",
      rows: [
      {
            name: "Role",
            type: "select",
            label: "Role",
            labelPosition: "left",
            labelWidth: 60,
            value: "",
            required: true,
            options: [
                {
                    value: "",
                    content: ""
                },
                {
                    value: "agent",
                    content: "agent"
                },
                {
                    value: "owner",
                    content: "owner"
                },
                {
                    value: "admin",
                    content: "admin"
                },
                {
                    value: "visitor",
                    content: "visitor"
                },
                {
                    value: "user",
                    content: "user"
                },
                {
                    value: "holder",
                    content: "holder"
                }
            ]
        },
        {
          type: "input",
          label: "Name",
          labelPosition: "left",
          labelWidth: 60,
          name: "deeplinkcustomname",
          icon: "dxi-magnify",
          placeholder: "",
        },
        {
          type: "input",
          label: "Initial Context",
          labelPosition: "left",
          name: "initialContext",
          icon: "dxi-magnify",
          placeholder: "{}",
          hidden: true
        },
        {
            align: "end",
            cols: [
                {
                    type: "button",
                    text: "Create",
                    id: "Create",
                    size: "medium",
                    view: "flat",
                    color: "primary",
                    padding: "2px"
                },
                {
                    type: "button",
                    text: "Save",
                    id: "Save",
                    size: "medium",
                    view: "flat",
                    color: "primary",
                    padding: "2px"
                },

            ]

        },
      ],
    });
    
    this.form.events.on("click", (id) => {
        console.log("Got id :"+id); 
        let newData = this.form.getValue();    
        console.log("got initial context",newData.initialContext);
        var client = window.botStore.getClientByViewPort(this.viewport); 
        let GrantPath = JSON.parse(client.CurrentContext);
        let GrantPE = GrantPath.GrantPE;
        //let InitialContext = document.getElementById('initialContext').value;
        let InitialContext  = {};
        let LocationContext = JSON.parse(client.LocationContext);
        console.log("location context",LocationContext);
        let signedURL = LocationContext.origin + '/DeviceManager/index.html';
        console.log("location context signedurl",signedURL);
        //let signedURL = '/DeviceManager/index.html';

        $.ajax({
        type:"POST",
        url:"/BotServices/bot/getSignedUrl",
        data: JSON.stringify({"Role":'visitor',"Component":client.ClientRight,"URL":signedURL,"InitialContext":InitialContext,"Name":newData.deeplinkcustomname}),
        dataType:"json",
        contentType:"application/json",
        success: function(res) {
             console.log("Got HTTP Response signedurl");
             console.log(res);
             document.getElementById("deeplinkdiv").style.display = "";
             document.getElementById("meetshorturllink").innerHTML= res.ShortURL; 
             console.log("meet short url",document.getElementById("meetshorturllink").innerHTML,"==",res.ShortURL);  
            }
        });
        //window.DevMgr.setMeeting(document.getElementById('initialContext').value);
        //this.DeepLinkpopupshow = false;
    });

    },
    copyToClipboard :  function() {
        var copyText = document.getElementById("meetshorturllink").innerHTML;
        navigator.clipboard.writeText(copyText);

        var tooltip = document.getElementById("myTooltip");
        tooltip.innerHTML = "Copied: " + copyText;
    },
    outFunc : function () {
      var tooltip = document.getElementById("myTooltip");
      tooltip.innerHTML = "Copy to clipboard";
    }
  }
}
</script>

<template>
<v-button style="display:none;" @click="show = true">Open modal</v-button>
<Popup v-model="DeepLinkpopupshow" >
  <template v-slot:title>Sharing Link</template>
  <template v-slot:content>
    <div ref="form"></div>
    <div id="deeplinkdiv" style="display: none;"><span class="label-text" id="meetshorturllink"></span>&nbsp;&nbsp;<div class="tooltip"><span class="far fa-copy" @click="copyToClipboard" @onmouseout="outFunc" style="color:#0072c5;cursor:pointer;"></span><span class="tooltiptext" id="myTooltip">Copy to clipboard</span></div></div>
    
    <form class="formbox" style="display:none;">
    <div class="form-group" style="display:flex;">
      <span class="label-text">Context</span>
      <input type="text" name="initialContext" id="initialContext" class="input-text" v-model="initialContext"/>
    </div>
    <div class="form-group" style="display:flex;">
      <span class="label-text">Output</span>
      <input type="text" name="output-signedurl" id="output-signedurl" class="input-text" />
    </div>    
  </form>
  </template>
</Popup>
</template>

<style>
.label-text {
    padding: 0 50px;
    font-size: inherit;
    overflow: hidden;
    /*text-overflow: ellipsis;*/
    white-space: nowrap;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
}
.input-text {
  background-color: white;
  border: 1px solid lightgray;
  width: 100%;
  display: block;
}
.ButtonText{
    margin-left: 145px;
    height: 25px;
    background-color: #0072c5;
    color: #fff;
    white-space: nowrap;
    align-items: center;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
    width:100%;
}

.formbox{
  max-width:460px;
  margin:auto;
  margin-top:35px;
  border:0px solid #2f2f2f;
  padding:24px;
  border-radius:4px;
}
#btn-submit{
  width:100%;
}
</style>
